import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { Configuration } from "Configuration";
import { IBaseResult, IUserMappingConfigResult, IUserMappingConfigContextParameter } from "Entities";
import { IUserGridConfigRequest } from "Entities/IUserGridConfigRequest";

/**
 * Service for requesting gridDefinitions.
 * @hidden
 */
export class UserGridConfigService extends BaseService {
    /**
     * Sets UserGridConfiguration
     * @param gridId
     * @param configuration
     */
    public setConfig(
        mappingName: string,
        isSystem: boolean,
        userMappingConfigId: number,
        name: string,
        userGridConfig: IUserGridConfigRequest[]
    ): Promise<IUserMappingConfigResult> {
        let param: IUserMappingConfigContextParameter = {
            MappingName: mappingName,
            IsSystem: isSystem,
            UserMappingConfigID: userMappingConfigId,
            Name: name,
            UserGridConfig: userGridConfig
        };

        let parameters = $.extend(param, CommandService.getRequestParameters());
        let url = Configuration.baseUrl + "usergridconfig/set";
        return this.post(url, parameters);
    }

    /**
     * Sets UserGridConfiguration
     * @param gridId
     * @param configuration
     */
    public deleteConfig(mappingName: string, userMappingConfigId: number): Promise<IBaseResult> {
        return this.sendCommonRequest(mappingName, userMappingConfigId, "usergridconfig/delete");
    }

    /**
     * Sets UserGridConfiguration
     * @param gridId
     * @param configuration
     */
    public setInitial(mappingName: string, userMappingConfigId: number): Promise<IBaseResult> {
        return this.sendCommonRequest(mappingName, userMappingConfigId, "usergridconfig/initial");
    }

    /**
     * Send a common request to the usergridconfig service.
     * @param mappingName Name of the mapping.
     * @param userMappingConfigId Id of the mapping config.
     * @param methodUrl Url of the method.
     */
    private sendCommonRequest(mappingName: string, userMappingConfigId: number, methodUrl: string): Promise<IBaseResult> {
        let param: IUserMappingConfigContextParameter = {
            UserMappingConfigID: userMappingConfigId,
            MappingName: mappingName
        };

        let parameters = $.extend(param, CommandService.getRequestParameters());
        let url = Configuration.baseUrl + methodUrl;
        return this.post(url, parameters);
    }
}
